import { UpdateUserRequest, usersApi } from '../services/usersApi';

export const updateUserQuery = ({ id, ...patch }: UpdateUserRequest) => {
  return usersApi.util.updateQueryData('getUserById', id, (draft) => {
    if (draft) {
      Object.assign(draft, patch.body);
    }
  });
};
